export const BRANDS_OVERVIEW_GET_DATA_REQUEST = "BRANDS_OVERVIEW_GET_DATA_REQUEST";
export const BRANDS_OVERVIEW_GET_DATA_RESULT = "BRANDS_OVERVIEW_GET_DATA_RESULT";